import React, { useState } from "react";
import GiftCardForm from "./GiftCardForm";
import AutoSearchAddForm from "./AutoSearchAddForm";
import { templateValidityText } from "@/lib/seriesValidity";

/**
 * "Gift Card / Series" tab. Left rail lets the operator pick WHAT
 * they're adding (gift card vs series); right side renders the matching
 * inline form. On mobile the rail stacks above the form as horizontal
 * chips — identical layout to the pre-refactor version.
 */
export default function GiftSeriesPanel({ series, giftTemplates, packages, services, branch, onAdd }) {
  const [giftSeriesSub, setGiftSeriesSub] = useState("gift-card"); // gift-card | series

  const subNavItem = (key, label, testid) => (
    <button
      key={key}
      type="button"
      onClick={() => setGiftSeriesSub(key)}
      data-testid={testid}
      className={
        "w-full text-left px-3 py-2 text-sm border-l-2 transition-colors " +
        (giftSeriesSub === key
          ? "border-primary bg-primary/5 text-primary font-medium"
          : "border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/40")
      }
    >
      {label}
    </button>
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-0 border border-border rounded-lg overflow-hidden md:min-h-[420px]">
      {/* Left rail — pick WHAT to add (Gift Card / Series). Packages
          now live on their own top-level tab. On mobile the rail
          stacks above the form as horizontal chips. */}
      <div className="bg-muted/30 border-b md:border-b-0 md:border-r border-border py-2 flex md:block gap-1 px-2 md:px-0 overflow-x-auto">
        {subNavItem("gift-card", "Gift Card", "sub-gift-card")}
        {subNavItem("series",    "Series",    "sub-series")}
      </div>

      {/* Right form — swaps based on the active sub-item. */}
      <div className="p-3 sm:p-4">
        {giftSeriesSub === "gift-card" && (
          <GiftCardForm
            templates={giftTemplates}
            services={services}
            packages={packages}
            branch={branch}
            onAdd={onAdd}
          />
        )}
        {giftSeriesSub === "series" && (
          <AutoSearchAddForm
            items={series}
            branch={branch}
            placeholder="Type a series name…"
            emptyHint="Start typing to search series created in Brand → Series."
            // Reception has to quote the validity out loud when they sell a
            // series, so the expiry contract rides along in the picker.
            metaFor={(row) => templateValidityText(row)}
            onAdd={(row, qty) => onAdd({ kind: "series", ref_id: row.id, name: `${row.name} (Series)`, quantity: qty, unit_price: row.price || 0, discount: 0 })}
            testidPrefix="add-series-item"
          />
        )}
      </div>
    </div>
  );
}
